import script from "./SlowDramaDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./SlowDramaDetailView.vue?vue&type=script&setup=true&lang=js"

import "./SlowDramaDetailView.vue?vue&type=style&index=0&id=23f739b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23f739b2"]])

export default __exports__